import { FC } from 'react';
//components
import SidebarList from 'components/common/SidebarList';
//constants
import { STAFF_SIDEBAR_LIST } from 'constants/index';

const StaffSidebar: FC = (): JSX.Element => <SidebarList list={STAFF_SIDEBAR_LIST} />;

export default StaffSidebar;
